var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"internal-notes"},[_c('RichTextArea',{attrs:{"value":_vm.internalNotes,"disabled":_vm.disabled,"max-length":10000,"placeholder":"内部メモをここに入力してください..."},on:{"change":function($event){return _vm.update($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }